<template>
  <h1
    :class="`mb-8 ${headlineClass}`"
    v-html="text"
  />
</template>
<script>
export default {
  name: 'Headline',
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    headlineClass () {
      return this.text.length > 100 ? 'sn-h4' : 'sn-h2'
    }
  }
}
</script>
